import React from "react";
import "./Partners.css";
import technopark from "../images/technopark.jpg";

const Partners = () => {
  return (
    <div className="partners-page-wrapper">
      {/* HERO SECTION */}
      <div
        className="bg-container-partners"
        style={{ backgroundImage: `url(${technopark})` }}
      ></div>

      <div className="partners-hero-wrapper">
        <div className="partners-hero-content">
          <h1>Our Ecosystem</h1>
          <h2>Collaborating with global leaders for secure banking.</h2>
          <p>
            Join the IGNOSI partner ecosystem where we collaborate with industry leaders to deliver secure, scalable, and intelligent financial infrastructures.
          </p>
        </div>
      </div>

      {/* TECHNOLOGY PARTNERS */}
      <section className="partners-grid-section">
        <div className="partner-category">
          <h3>Technology Partners</h3>
          <div className="partner-grid-premium">
            {["AWS", "Google Cloud", "Cloudflare", "Docker", "Digital Ocean"].map((p) => (
              <div className="partner-card-premium" key={p}>{p}</div>
            ))}
          </div>
        </div>

        {/* BANKING & PAYMENT */}
        <div className="partner-category offset-bg">
          <h3>Banking & Payment Partners</h3>
          <div className="partner-grid-premium">
            {["Razorpay","Cashfree","SIB","I Serve u"].map((p) => (
              <div className="partner-card-premium" key={p}>{p}</div>
            ))}
          </div>
        </div>

        {/* AUDIT & COMPLIANCE */}
        {/* <div className="partner-category">
          <h3>Audit & Compliance Partners</h3>
          <div className="partner-grid-premium">
            {["KPMG", "Deloitte", "PwC", "EY", "ISO Certified Bodies"].map((p) => (
              <div className="partner-card-premium" key={p}>{p}</div>
            ))}
          </div>
        </div> */}

        {/* INTEGRATION */}
        <div className="partner-category offset-bg">
          <h3>Integration Partners</h3>
          <div className="partner-grid-premium">
            {["Core Banking APIs", "KYC Providers", "SMS Gateway Providers", "Payment Switch Networks", "Accounting Software APIs"].map((p) => (
              <div className="partner-card-premium" key={p}>{p}</div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="partners-cta-section">
        <div className="cta-content-partners">
          <h2>Grow With Us</h2>
          <p>
            Join IGNOSI and be part of transforming traditional banking into intelligent financial ecosystems. Let's build the future of fintech together.
          </p>
          {/* <h3 className="partner-btn-premium">Partner With Us</h3> */}
        </div>
      </section>
    </div>
  );
};

export default Partners;